import type { ReactNode } from "react";
import { vars } from "@pack-it-up/ui-web";

// Compact sticky topbar shared by My Trips and My Templates: a title plus an optional
// right-aligned slot (the search box), mirroring Home's topbar.
export const PageHeader = ({ title, right }: { title: string; right?: ReactNode }): ReactNode => (
  <div
    style={{
      height: "56px",
      borderBottom: `1px solid ${vars.color.border}`,
      display: "flex",
      alignItems: "center",
      padding: `0 ${vars.space.xl}`,
      gap: vars.space.md,
      background: vars.color.background,
      flexShrink: 0,
      position: "sticky",
      top: 0,
      zIndex: 10,
    }}
  >
    <h1
      style={{
        fontFamily: vars.font.heading,
        fontWeight: vars.font.weightBold,
        fontSize: "17px",
        letterSpacing: vars.font.trackingSnug,
        margin: 0,
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </h1>
    {right}
  </div>
);
